// extracted by mini-css-extract-plugin
module.exports = {"lds_ring_container":"Loader_lds_ring_container__3lMjM","lds_ring":"Loader_lds_ring__3brDr"};